import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-datetimepicker',
  templateUrl: './datetimepicker.component.html',
  styleUrls: ['./datetimepicker.component.scss']
})
export class DatetimepickerComponent {

  dateandtime: any = [];
  selectedDate: any ="";
  selectedTime: any ="";
  currentDate = new Date();
  today = this.currentDate.getDate();
  isdatetimenotselected = false;
  isdatenotselected = false;
  istimenotselected = false;
fromwhere:any;
  constructor(public dialogRef: MatDialogRef<DatetimepickerComponent>, @Inject(MAT_DIALOG_DATA) public data: any){
    
  }

  ngOnInit() {
    // this.check();
if(this.data){
 this.fromwhere=this.data;
}
  }

  itemSelected(value: any, check: string) {

    if (check == 'date') {
      this.selectedDate = value;
      this.isdatenotselected = false;
    }
    else {
      this.selectedTime = value;
      this.istimenotselected = false;
    }

    this.dateandtime.push({
      date: this.selectedDate,
      time: this.selectedTime ,
    })
    

  }


  submitDateAndTime(dateandtimearray:any){


    if(this.selectedDate != "" && this.selectedTime != ""){
      this.isdatenotselected = false;
        this.istimenotselected = false;
        this.isdatetimenotselected  = false;
      this.dialogRef.close(dateandtimearray);
    }else{
      if(this.selectedDate == "" && this.selectedTime != ""){
        this.isdatenotselected = true;
        this.istimenotselected = false;
        this.isdatetimenotselected  = false;
      }
      if(this.selectedDate != "" && this.selectedTime == ""){
        this.istimenotselected = true;
        this.isdatenotselected = false;
        this.isdatetimenotselected  = false;
      }
      if(this.selectedDate == "" && this.selectedTime == ""){
        this.isdatetimenotselected  = true;
        this.isdatenotselected = false;
        this.istimenotselected = false;
      }
      

    }

  }
  submitDate(dateandtimearray:any){
    console.log(dateandtimearray);
    this.dialogRef.close(dateandtimearray);
  }
  
}
